import * as React from 'react';
import Box from '../components/Box/Box';

export const VideoPlayIcon = (props) => (
    <Box
        as="svg"
        width={126}
        height={126}
        viewBox="0 0 126 126"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={63} cy={63} r={35.4375} fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M63 5.25C31.1056 5.25 5.25 31.1056 5.25 63C5.25 94.8944 31.1056 120.75 63 120.75C94.8944 120.75 120.75 94.8944 120.75 63C120.75 31.1056 94.8944 5.25 63 5.25ZM50.3986 42.6094C49.875 43.3089 49.875 44.5618 49.875 47.0675V78.9315C49.875 81.4373 49.875 82.6901 50.3986 83.3896C50.855 83.9991 51.5535 84.3805 52.313 84.4347C53.1845 84.497 54.2384 83.8195 56.3461 82.4645L81.1293 66.5325C82.9583 65.3567 83.8728 64.7688 84.1887 64.0212C84.4647 63.368 84.4647 62.631 84.1887 61.9778C83.8728 61.2303 82.9583 60.6424 81.1293 59.4666L56.3462 43.5345C54.2384 42.1796 53.1845 41.502 52.313 41.5643C51.5535 41.6185 50.855 41.9999 50.3986 42.6094Z"
            fill="#44474C"
        />
    </Box>
);
